import axios from "axios";
import { useEffect, useState } from "react";
import "./Seminar.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const Seminar = () => {
    const [seminars, setSeminars] = useState([]);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [currentSeminar, setCurrentSeminar] = useState({});
    const [formData, setFormData] = useState({
        title: "",
        seminarId: null,
        description: "",
        guestImage: null,
        seminarDate: "",
        seminarTime: "",
        seminarPrice: 0,
        meetingUrl: "",
        meetingPasscode: "",
        createdAt: "",
        expiresAt: "",
        goLiveAt: "",
        isEnabled: true,
    });

    // Generate a unique guest image name
    const generateUniqueCode = () => `IMG_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const fetchSeminars = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/seminar/getSeminars.php`);
            setSeminars(response.data.seminars);
        } catch (error) {
            console.error("Error fetching seminars:", error);
        }
    };

    const handleAddSeminar = async () => {
        const updatedData = {
            ...formData,
            createdAt: new Date().toLocaleString(),
        };

        try {
            const formDataToSend = new FormData();

            // Append form data fields individually
            Object.keys(updatedData).forEach(key => {
                if (updatedData[key] !== undefined) {
                    formDataToSend.append(key, updatedData[key]);
                }
            });

            // Send the FormData to the backend
            await axios.post(`${BASE_URL}/seminar/addSeminar.php`, formDataToSend);
            fetchSeminars();
            setShowAddPopup(false);
        } catch (error) {
            console.error("Error adding seminar:", error);
        }
    };

    const handleEditSeminar = async () => {

        try {
            const formDataToSend = new FormData();

            console.log(currentSeminar);

            // Append seminar fields individually
            Object.keys(currentSeminar).forEach(key => {
                if (currentSeminar[key] !== undefined) {
                    formDataToSend.append(key, currentSeminar[key]);
                }
            });

            const formDataObj = Object.fromEntries(formDataToSend);
            console.log(formDataObj);

            // Send the FormData to the backend
            await axios.post(`${BASE_URL}/seminar/updateSeminar.php`, formDataToSend);
            fetchSeminars();
            setShowEditPopup(false);
        } catch (error) {
            console.error("Error editing seminar:", error);
        }
    };

    const handleDeleteSeminar = async (seminarId) => {

        if (window.confirm("Are you sure you want to delete this seminar?")) {
            try {
                await axios.put(`${BASE_URL}/seminar/deleteSeminar.php`, { seminarId: seminarId });
                fetchSeminars();
            } catch (error) {
                console.error("Error deleting seminar:", error);
            }
        }
    };

    const handleToggleEnabled = async (seminarId, isEnabled) => {
        try {
            await axios.put(`${BASE_URL}/seminar/toggle.php`, { seminarId, isEnabled: !isEnabled });
            fetchSeminars();
        } catch (error) {
            console.error("Error toggling isEnabled:", error);
        }
    };

    useEffect(() => {
        fetchSeminars();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        const allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

        if (file && !allowedExtensions.includes(file.type)) {
            alert('Invalid file type. Please upload a PNG, JPEG, or JPG file.');
            e.target.value = '';
            return;
        }

        const uniqueCode = generateUniqueCode(); // generate unique code for the image
        const fileName = `${uniqueCode}_${file.name}`; // Create a unique file name using the generated code

        setFormData({
            ...formData,
            guestImage: file,
            guestImageName: fileName, // store the generated file name
        });
    };

    const handleEditFileChange = (e) => {
        const file = e.target.files[0];

        const allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

        if (file && !allowedExtensions.includes(file.type)) {
            alert('Invalid file type. Please upload a PNG, JPEG, or JPG file.');
            e.target.value = '';
            return;
        }

        const uniqueCode = generateUniqueCode(); // generate unique code for the image
        const fileName = `${uniqueCode}_${file.name}`; // Create a unique file name using the generated code

        setCurrentSeminar({
            ...currentSeminar,
            newGuestImage: file,
            newGuestImageName: fileName, // store the generated file name
        });
    };

    return (
        <div className="seminar-container">
            <h1>Seminars</h1>
            <button onClick={() => setShowAddPopup(true)} className="seminar-add-button">
                Add Seminar
            </button>

            <table className="seminar-table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Guest</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Enabled</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {seminars.map((seminar) => (
                        <tr key={seminar.seminarId}>
                            <td>{seminar.title}</td>
                            <td>
                                {seminar.guestImageName ? (
                                    <img
                                        src={`${BASE_URL}/images/guests/${seminar.guestImageName}`}
                                        alt={seminar.title}
                                        className='profile-image'
                                    />
                                ) : (
                                    <p>No Image</p>
                                )}
                            </td>
                            <td>{seminar.description}</td>
                            <td>{seminar.seminarDate}</td>
                            <td>{seminar.seminarTime}</td>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={seminar.isEnabled}
                                    onChange={() => handleToggleEnabled(seminar.seminarId, seminar.isEnabled)}
                                />
                            </td>
                            <td>
                                <button
                                    onClick={() => {
                                        setShowEditPopup(true);
                                        setCurrentSeminar(seminar);
                                    }}
                                >
                                    Edit
                                </button>
                                <button onClick={() => handleDeleteSeminar(seminar.seminarId)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Add Seminar Pop-Up */}
            {showAddPopup && (
                <div className="seminar-pop-up">
                    <div className="seminar-pop-up-content">
                        <h2>Add Seminar</h2>
                        <label>Title</label>
                        <input
                            type="text"
                            placeholder="Title"
                            value={formData.title}
                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                        />
                        <label>Description</label>
                        <textarea
                            placeholder="Description"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        ></textarea>
                        <label>Guest Image</label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label>Date</label>
                        <input
                            type="date"
                            value={formData.seminarDate}
                            onChange={(e) => setFormData({ ...formData, seminarDate: e.target.value })}
                        />
                        <label>Time</label>
                        <input
                            type="time"
                            value={formData.seminarTime}
                            onChange={(e) => setFormData({ ...formData, seminarTime: e.target.value })}
                        />
                        <label>Seminar Price</label>
                        <input
                            type="number"
                            placeholder="Seminar Price"
                            value={formData.seminarPrice}
                            onChange={(e) => setFormData({ ...formData, seminarPrice: e.target.value })}
                        />
                        <label>Meeting URL</label>
                        <input
                            type="text"
                            placeholder="Meeting URL"
                            value={formData.meetingUrl}
                            onChange={(e) => setFormData({ ...formData, meetingUrl: e.target.value })}
                        />
                        <label>Meeting Passcode</label>
                        <input
                            type="text"
                            placeholder="Meeting Passcode"
                            value={formData.meetingPasscode}
                            onChange={(e) => setFormData({ ...formData, meetingPasscode: e.target.value })}
                        />
                        {/* <label>Expires At</label>
                        <input
                            type="datetime-local"
                            placeholder="Expires At"
                            onChange={(e) => setFormData({ ...formData, expiresAt: e.target.value })}
                        />
                        <label>Go Live At</label>
                        <input
                            type="datetime-local"
                            placeholder="Go Live At"
                            onChange={(e) => setFormData({ ...formData, goLiveAt: e.target.value })}
                        /> */}
                        <button onClick={handleAddSeminar}>Submit</button>
                        <button onClick={() => setShowAddPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            {/* Edit Seminar Pop-Up */}
            {showEditPopup && (
                <div className="seminar-pop-up">
                    <div className="seminar-pop-up-content">
                        <h2>Edit Seminar</h2>
                        <label>Title</label>
                        <input
                            type="text"
                            value={currentSeminar.title}
                            onChange={(e) =>
                                setCurrentSeminar({ ...currentSeminar, title: e.target.value })
                            }
                        />
                        <label>Description</label>
                        <textarea
                            value={currentSeminar.description}
                            onChange={(e) =>
                                setCurrentSeminar({ ...currentSeminar, description: e.target.value })
                            }
                        ></textarea>
                        <label>Guest Image</label>
                        <input
                            type="file"
                            onChange={handleEditFileChange}
                        />
                        <label>Date</label>
                        <input
                            type="date"
                            value={currentSeminar.seminarDate}
                            onChange={(e) =>
                                setCurrentSeminar({ ...currentSeminar, seminarDate: e.target.value })
                            }
                        />
                        <label>Time</label>
                        <input
                            type="time"
                            value={currentSeminar.seminarTime}
                            onChange={(e) =>
                                setCurrentSeminar({ ...currentSeminar, seminarTime: e.target.value })
                            }
                        />
                        <label>Seminar Price</label>
                        <input
                            type="number"
                            placeholder="Seminar Price"
                            value={currentSeminar.seminarPrice}
                            onChange={(e) => setCurrentSeminar({ ...currentSeminar, seminarPrice: e.target.value })}
                        />
                        <label>Meeting URL</label>
                        <input
                            type="text"
                            placeholder="Meeting URL"
                            value={currentSeminar.meetingUrl}
                            onChange={(e) => setCurrentSeminar({ ...currentSeminar, meetingUrl: e.target.value })}
                        />
                        <label>Meeting Passcode</label>
                        <input
                            type="text"
                            placeholder="Meeting Passcode"
                            value={currentSeminar.meetingPasscode}
                            onChange={(e) => setCurrentSeminar({ ...currentSeminar, meetingPasscode: e.target.value })}
                        />
                        <button onClick={handleEditSeminar}>Save</button>
                        <button onClick={() => setShowEditPopup(false)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Seminar;
